import { Component, OnInit } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { TranslateService } from '@ngx-translate/core';

import { CustomPopupComponent } from '../custom-popup/custom-popup.component';

@Component({
  selector: 'app-range-date',
  templateUrl: './range-date.component.html',
  styleUrls: ['./range-date.component.sass']
})
export class RangeDateComponent implements OnInit {
  rangeDateForm: FormGroup;
  showBar: boolean = false;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });
  constructor(
    private selfRef: MatDialogRef<RangeDateComponent>,
    public auth: AngularFireAuth,
    public fb: FormBuilder,
    private snackbar: MatSnackBar,
    private dataService: DataService,
    private translate: TranslateService,
  ) {
    // this.rangeDateForm = fb.group({
    //   start_date: new FormControl('', [Validators.required, Validators.email]),
    //   end_date: new FormControl('', [Validators.required, Validators.email])
    // })
  }

  ngOnInit(): void {
  }


  getRangeDate(form: FormGroup) {
    this.showBar = true;

    if (!this.range.controls.start.valid || !this.range.controls.end.valid) {

      this.translate.get('alerts.invalid_range_dates').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
      })

      this.showBar = false;
      // throw new Error('Invalid range dates')
      return false
    }

    let start_date = this.range.controls.start.value.toISOString()
    let end_date = this.range.controls.end.value.toISOString()    
    
    end_date = end_date.replace('00:00:00.000', '23:59:59.999')
    
    this.selfRef.close({"start_date": start_date, "end_date": end_date});
    // this.selfRef.close();




  }

}
